import type { SportsApi } from "@/v2/api/metadata/sports";
import type { ContentTab, DialogTabSaveContext } from "@/v2/framework/dialog/types";
import {
  buildSupplementalNamesPatch,
  syncSupplementalNamesBaseline,
} from "@/v2/kits/supplemental-names";
import { createInheritableTabSave } from "@/v2/kits/tenant-inheritance";
import { sportStatusOptions } from "../../../../shared";
import { notifySuccess, sportId } from "../shared";

const mainTabChildren: ContentTab["children"] = [
  {
    type: "select-field",
    name: "status",
    label: "Status",
    required: true,
    placeholder: "Select status",
    options: sportStatusOptions,
    inheritance: {
      computedKey: "computedStatus",
      parentKey: "parentStatus",
    },
  },
  {
    type: "text-field",
    name: "name",
    label: "Name",
    placeholder: "Enter name",
    inheritance: {
      computedKey: "computedName",
      parentKey: "parentName",
    },
    validate: (value, values) => {
      if (values.isTenantSourceOfEntity && !String(value ?? "").trim()) {
        return "Required";
      }
      return undefined;
    },
  },
  {
    type: "text-field",
    name: "info",
    label: "Info",
    placeholder: "Enter info",
    inheritance: {
      computedKey: "computedInfo",
      parentKey: "parentInfo",
    },
  },
  {
    type: "text-field",
    name: "code",
    label: "Code",
    placeholder: "Enter code",
    inheritance: {
      computedKey: "computedCode",
      parentKey: "parentCode",
    },
  },
];

export function createMainTab(sportsApi: SportsApi): ContentTab {
  const save = createInheritableTabSave({
    children: mainTabChildren,
    buildExtraPatch: (ctx) => buildSupplementalNamesPatch(ctx.values, ctx.baseline),
    afterPersist: syncSupplementalNamesBaseline,
    persist: async (patch, ctx: DialogTabSaveContext) => {
      await sportsApi.update(sportId(ctx.values), patch);
      notifySuccess();
    },
  });

  return {
    id: "main",
    label: "Main",
    save,
    children: [
      ...mainTabChildren,
      {
        type: "component",
        component: () =>
          import("@/v2/kits/supplemental-names/components/SupplementalNamesFields.vue"),
        props: { mode: "edit", entity: "SPORT" },
      },
    ],
  };
}
